<div *ngIf="committeeMember && committee" class="atlas-form">
  <div>
    <div>
      <div class="mct-flex mct-row" *ngIf="profile; else noProfile">
        <wl-profile-type-icon
          [isMember]="profile.Member"
          [isOrg]="profile.OrgInd"
          [styleOverrides]="{ 'max-height': '34px', 'max-width': '34px' }"
          [profileId]="profile.ProfileId"
          [memberTypeIconColor]="profile.MemberTypeIconColor"
        ></wl-profile-type-icon>
        <h4>
          {{ profile.ReportName }} <span class="light-text">({{ profile.ProfileId }})</span>
        </h4>
      </div>
      <ng-template #noProfile>
        <wl-busy [show]="true"></wl-busy>
      </ng-template>
    </div>
    <div class="mct-grid mct-cols-1-1 mct-grid-lt-md mct-cols-auto-lt-md mct-gap-27">
      <div class="mct-flex mct-col mct-gap-27">
        <div>
          <label>{{ 'committees.edit.committee-members.crud-dialog.committee-role' | translate | ucfirst }}</label>
          <input name="committeeRole" [(ngModel)]="committeeMember.Title" />
        </div>
        <div>
          <label>{{ 'committees.edit.committee-members.crud-dialog.internal-notes' | translate | ucfirst }}</label>
          <textarea class="w-100" cols="120" pInputTextarea name="notes" [(ngModel)]="committeeMember.Notes"></textarea>
        </div>
        <div>
          <div>
            <label>
              <i *ngIf="usesDefaultRepresentingOrganization" class="pi pi-lock green"></i>
              {{ 'committees.edit.committee-members.crud-dialog.representing-organization' | translate | ucfirst }}</label
            >
            <p-select
              name="representing-organization"
              [style]="{ width: '100%' }"
              [(ngModel)]="representingOrganization"
              [options]="representingOrganizationsTypeItems"
              (onChange)="updateRepresentingOrganization()"
              showClear
              [disabled]="usesDefaultRepresentingOrganization"
            ></p-select>
          </div>
          <ng-container>
            <div class="mv-10">
              <span *ngIf="usesDefaultRepresentingOrganization; else usesManualRepresentingOrganizationText">
                <i *ngIf="usesDefaultRepresentingOrganization" class="pi pi-lock green"></i>
                {{ 'committees.edit.committee-members.crud-dialog.this-organization-default' | translate | ucfirst }}
              </span>
              <ng-template #usesManualRepresentingOrganizationText>
                <span>{{
                  'committees.edit.committee-members.crud-dialog.the-default-method-has-been-overridden' | translate | ucfirst
                }}</span>
              </ng-template>
            </div>
            <div class="mv-10">
              <a
                *ngIf="usesDefaultRepresentingOrganization; else usesManualRepresentingOrganizationLink"
                [class.disable-link]="!representingOrganizationsTypeItems.length"
                (click)="representingOrganizationsTypeItems.length && (usesDefaultRepresentingOrganization = false)"
                >{{
                  'committees.edit.committee-members.crud-dialog.override-this-and-manually-select-an-organization' | translate | ucfirst
                }}
              </a>
              <ng-template #usesManualRepresentingOrganizationLink>
                <a (click)="useDefaultRepresentingOrganization()">
                  {{ 'committees.edit.committee-members.crud-dialog.use-the-default-representing-organization' | translate | ucfirst }}
                </a>
              </ng-template>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="mct-flex mct-col mct-gap-27">
        <div class="mv-31 mct-flex mct-row">
          <p-checkbox name="activeMember" [(ngModel)]="committeeMember.Active" [binary]="true" inputId="activeMember"> </p-checkbox>
          <label for="activeMember">
            {{ 'committees.edit.committee-members.crud-dialog.active-member' | translate | ucfirst }}
          </label>
        </div>
        <div class="mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-gap-27">
          <div>
            <label>{{ 'committees.edit.committee-members.crud-dialog.start-date' | translate | ucfirst }}</label>
            <wl-date-selector
              name="startDate"
              appendTo="body"
              [(ngModel)]="committeeMember.MemberSince"
              (ngModelChange)="memberSinceChanged()"
            ></wl-date-selector>
          </div>
          <div *ngIf="committeeMember.Active; else memberInactive">
            <label class="mct-flex mct-row mct-justify-start mct-items-center">
              <i *ngIf="usesDefaultTerm" class="pi pi-lock green"></i>
              {{ 'committees.edit.committee-members.crud-dialog.expiration-date' | translate | ucfirst }}
            </label>
            <wl-date-selector
              name="expirationDate"
              appendTo="body"
              [(ngModel)]="committeeMember.TermExpires"
              [disabled]="usesDefaultTerm || neverExpires"
            ></wl-date-selector>
            <div class="mct-flex mct-row">
              <label for="neverExpires">
                {{ 'committees.edit.committee-members.crud-dialog.never-expires' | translate | ucfirst }}
              </label>
              <p-checkbox
                name="neverExpires"
                binary="true"
                [(ngModel)]="neverExpires"
                [disabled]="usesDefaultTerm"
                inputId="neverExpires"
                (onChange)="neverExpiresChanged()"
              >
              </p-checkbox>
            </div>
          </div>
          <ng-template #memberInactive>
            <div>
              <label class="mct-flex mct-row mct-justify-start mct-items-center">
                {{ 'committees.edit.committee-members.crud-dialog.inactive-date' | translate | ucfirst }}
              </label>
              <wl-date-selector name="inactiveDate" appendTo="body" [(ngModel)]="committeeMember.DateInactive"></wl-date-selector>
            </div>
          </ng-template>
        </div>

        <div class="mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-center mct-items-start mct-gap-27">
          <div class="mct-flex mct-col mct-gap-27 mct-flex-1-1-0 mct-offset-43">
            <ng-container *ngIf="committeeMember.Active">
              <div>
                <span *ngIf="usesDefaultTerm; else usesManual">
                  <i class="pi pi-lock green"></i>
                  {{ 'committees.edit.committee-members.crud-dialog.this-expiration-default-term' | translate | ucfirst }}
                  <strong>{{ defaultTermText | uppercase }}</strong>
                </span>
                <ng-template #usesManual>
                  <span>{{ 'committees.edit.committee-members.crud-dialog.this-expiration-date-was-set' | translate | ucfirst }}</span>
                </ng-template>
              </div>
              <div>
                <a *ngIf="usesDefaultTerm; else useManual" (click)="usesDefaultTerm = false">{{
                  'committees.edit.committee-members.crud-dialog.use-custom-expiration-settings' | translate | ucfirst
                }}</a>
                <ng-template #useManual>
                  <a (click)="useDefaultTerm()">
                    {{ 'committees.edit.committee-members.crud-dialog.use-the-default-of' | translate | ucfirst }}
                    <strong>{{ defaultTermText | uppercase }}</strong>
                    {{ 'committees.edit.committee-members.crud-dialog.instead' | translate }}
                  </a>
                </ng-template>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  <hr />

  <div class="mb-27 mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-gap-27">
    <div class="mct-flex-1-1-0">
      <label>{{ 'committees.edit.committee-members.crud-dialog.custom' | translate | ucfirst }} 1</label>
      <input name="custom1" [(ngModel)]="committeeMember.Custom1" />
    </div>
    <div class="mct-flex-1-1-0">
      <label>{{ 'committees.edit.committee-members.crud-dialog.custom' | translate | ucfirst }} 2</label>
      <input name="custom2" [(ngModel)]="committeeMember.Custom2" />
    </div>
  </div>

  <div class="mb-27 mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-gap-27">
    <div class="mct-flex-1-1-0">
      <label>{{ 'committees.edit.committee-members.crud-dialog.custom' | translate | ucfirst }} 3</label>
      <input name="custom3" [(ngModel)]="committeeMember.Custom3" />
    </div>
    <div class="mct-flex-1-1-0">
      <label>{{ 'committees.edit.committee-members.crud-dialog.custom' | translate | ucfirst }} 4</label>
      <input name="custom4" [(ngModel)]="committeeMember.Custom4" />
    </div>
  </div>

  <div class="mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-gap-27">
    <div class="mct-flex-1-1-0">
      <label>{{ 'committees.edit.committee-members.crud-dialog.custom' | translate | ucfirst }} 5</label>
      <input name="custom5" [(ngModel)]="committeeMember.Custom5" />
    </div>
    <div class="mct-flex-1-1-0"></div>
  </div>
</div>
